import { gql } from "urql";
export const PublicPriorityEmailRecordQuery = gql `
    query PublicPriorityEmailRecord($key1: String!, $key2: String!) {
        priorityEmailRecords {
            priorityEmailRecord(key1: $key1, key2: $key2) {
                organizationName
                patientName
                therapyCategoryName
                priorityEmailType
                intakeFormUrl
            }
        }
    }
`;
